import { AuthenticationInfo } from "types/AuthenticationInfo";
import { createCustomAction, createAction } from "typesafe-actions";

const AUTHENTICATIONINFO_DATA_LOAD = "authenticationinfo/AUTHENTICATIONINFO_DATA_LOAD";
const AUTHENTICATIONINFO_DATA_LOAD_SUCCESS =
  "authenticationinfo/AUTHENTICATIONINFO_DATA_LOAD_SUCCESS";
const AUTHENTICATIONINFO_DATA_LOAD_FAIL = "authenticationinfo/AUTHENTICATIONINFO_DATA_LOAD_FAIL";

export const load = createAction(AUTHENTICATIONINFO_DATA_LOAD);

export const loadSuccess = createCustomAction(
  AUTHENTICATIONINFO_DATA_LOAD_SUCCESS,
  (type) => (data?: AuthenticationInfo[]) => ({
    type,
    data,
  })
);

export const loadFail = createCustomAction(
  AUTHENTICATIONINFO_DATA_LOAD_FAIL,
  (type) => (error?: string) => ({
    type,
    error,
  })
);
